import { render, staticRenderFns } from "./ItemTabOverview.vue?vue&type=template&id=467360f8&scoped=true&"
import script from "./ItemTabOverview.vue?vue&type=script&lang=js&"
export * from "./ItemTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./ItemTabOverview.vue?vue&type=style&index=0&id=467360f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467360f8",
  null
  
)

export default component.exports